import { createRequest } from '../Helpers/GenericHelpers'
import { updateMarketplaceColumnsFilter, updateDefaultColumns } from '../Slices/Kiosk/TableOptionsSlice'
import { getTokenFromSessionStorage } from '../Helpers/TokenHelper'

const getMarketplace = (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest('/api/market/all/?&config=' + state.present.article.serverConfig, 'GET', undefined, token).then(
    response => response.json(),
  )
}

const setMarketplaceFilters = (dispatch, getState) => {
  const state = getState()
  const allMarketplace = state.present.configuration.allMarketplace
  dispatch(updateMarketplaceColumnsFilter({ mktAlias: allMarketplace }))
  dispatch(updateDefaultColumns({ mktAlias: allMarketplace }))
}

export { getMarketplace, setMarketplaceFilters }
